module.exports = __webpack_public_path__ + "img/profile.95c74e73.png";